export default {
  site_name: 'CSSBuy Spreadsheet',
  home: 'Início',
  categories: 'Categorias',
  guides: 'Guias',
  search: 'Pesquisar',
  search_placeholder: 'Pesquisar produto, categoria ou palavra-chave...',
  language: 'Idioma',
  hero_title: 'CSSBuy Spreadsheet: Encontre e Compare Produtos',
  hero_subtitle: 'Explore a CSSBuy Spreadsheet, encontre produtos, compare opções e veja guias sobre QC, envio, custos, armazém, segurança e compras.',
  explore_spreadsheet: 'Explorar CSSBuy Spreadsheet',
  buy_now: 'Buy It Now',
  view_full_guide: 'Ver Guia Completo',
  trust_text: 'Recurso independente · Conteúdo atualizado · Pesquisa organizada · PT-BR + English + Deutsch',
  popular_categories: 'Categorias Populares',
  shoes: 'Tênis',
  hoodies_sweaters: 'Moletons',
  t_shirts: 'Camisetas',
  jackets: 'Jaquetas',
  pants_shorts: 'Calças',
  headwear: 'Bonés',
  sets: 'Conjuntos',
  underwear: 'Underwear',
  jersey: 'Jersey',
  accessories: 'Acessórios',
  bags: 'Bolsas',
  belts: 'Cintos',
  perfumes: 'Perfumes',
  other_stuff: 'Outros',
  why_spreadsheet: 'Por que usar a CSSBuy Spreadsheet?',
  organized_research: 'Pesquisa Organizada',
  organized_research_desc: 'Encontre informações de produtos em uma estrutura simples e organizada.',
  compare_options: 'Compare Opções',
  compare_options_desc: 'Compare categorias, vendedores e informações antes de comprar.',
  qc_guide: 'Guia de QC',
  qc_guide_desc: 'Entenda quais pontos observar antes de confirmar sua compra.',
  save_time: 'Economize Tempo',
  save_time_desc: 'Encontre produtos com pesquisa e filtros de forma rápida e eficiente.',
  cssbuy_review: 'CSSBuy Review 2026',
  review_desc: 'Confira informações sobre recursos, QC, armazém, envio, custos e possíveis riscos.',
  read_review: 'Ler CSSBuy Review',
  shipping_cost: 'CSSBuy Shipping Cost',
  shipping_desc: 'O custo varia conforme peso, dimensões, destino e método de transporte.',
  view_shipping_guide: 'Ver Guia de Shipping',
  coupon: 'CSSBuy Coupon & Discount Code',
  coupon_desc: 'Confira informações sobre cupons e promoções. Sempre confirme a validade diretamente na plataforma.',
  view_coupons: 'Ver Cupons e Descontos',
  warehouse: 'CSSBuy Warehouse Guide',
  warehouse_desc: 'Entenda armazenamento, QC, consolidação e preparação do pedido.',
  safety: 'CSSBuy é Legit e Seguro?',
  safety_desc: 'Explique riscos relacionados a vendedores, pagamentos, links externos, QC, envio, alfândega e reembolsos.',
  view_safety_guide: 'Ver CSSBuy Safety Guide',
  comparison: 'CSSBuy vs Outras Plataformas',
  comparison_desc: 'Compare CSSBuy, Superbuy, Sugargoo, Oopbuy, AllChinaBuy e outras plataformas relevantes.',
  latest_articles: 'Artigos Recentes',
  faq: 'FAQ',
  faq_what_is: 'O que é CSSBuy Spreadsheet?',
  faq_how_to_use: 'Como usar CSSBuy Spreadsheet?',
  faq_legit: 'CSSBuy é legítima?',
  faq_safe: 'CSSBuy é segura?',
  faq_shipping_cost: 'Quanto custa o envio?',
  faq_qc: 'Como funciona QC?',
  faq_warehouse: 'O que é Warehouse?',
  faq_find_products: 'Como encontrar produtos?',
  faq_brazil: 'CSSBuy envia para o Brasil?',
  faq_coupons: 'Onde encontrar cupons?',
  final_cta: 'Pronto para explorar a CSSBuy Spreadsheet?',
  final_cta_desc: 'Pesquise produtos, compare informações e consulte nossos guias antes de continuar para o site principal.',
  footer_about: 'Sobre',
  footer_contact: 'Contato',
  footer_disclaimer: 'Disclaimer',
  footer_privacy: 'Privacidade',
  footer_terms: 'Termos',
  footer_rights: 'Todos os direitos reservados.',
  article_read_more: 'Ler mais',
  article_spreadsheet_guide: 'CSSBuy Spreadsheet 2026 — Guia Completo',
  article_spreadsheet_desc: 'Descubra tudo sobre a CSSBuy Spreadsheet: como encontrar produtos, usar filtros, verificar QC e comparar preços. Guia atualizado para 2026.',
  article_shipping_guide: 'CSSBuy Shipping Cost Guide 2026',
  article_shipping_guide_desc: 'Entenda os custos de envio, métodos disponíveis, prazos e como calcular o frete para o Brasil e Europa.',
  article_safety_guide: 'CSSBuy é Seguro? Safety Guide',
  article_safety_guide_desc: 'Análise completa sobre segurança, riscos de vendedores, proteção de pagamentos e como evitar problemas.',
  spreadsheet_page_title: 'CSSBuy Spreadsheet 2026 — Complete Product & Buying Guide',
  what_is_spreadsheet: 'O que é CSSBuy Spreadsheet?',
  how_it_works: 'Como Funciona',
  how_to_find: 'Como Encontrar Produtos',
  product_categories: 'Categorias de Produtos',
  seller_research: 'Pesquisa de Vendedores',
  latest_updates: 'Atualizações Recentes',
  cta: 'Continuar para o Site Principal',
  category_filter: 'Filtrar por Categoria',
  price_filter: 'Preço',
  popularity_filter: 'Popularidade',
  qc_filter: 'QC',
  seller_filter: 'Vendedor',
  update_filter: 'Atualização',
  streetwear: 'Streetwear',
  sportswear: 'Sportswear',
  clothing: 'Roupas',
  sneakers: 'Sneakers',
  back_to_home: 'Voltar para o Início',
  published_date: 'Publicado',
  updated_date: 'Atualizado',
  author: 'Autor',
  sources: 'Fontes',
  related_articles: 'Artigos Relacionados',
  table_of_contents: 'Índice',
  disclaimer_text: 'Este é um site de informação independente e não é o site oficial da CSSBuy. Todos os links externos levam para o site principal.',
  view_guide: 'Ver Guia',
  continue_to_main: 'Continuar para o Site Principal',
  learn_more: 'Saiba mais',
  read_article: 'Ler Artigo',
  see_all: 'Ver todos',
  search_results: 'Resultados da Pesquisa',
  no_results: 'Nenhum resultado encontrado',
  all_categories: 'Todas as Categorias',
  spreadsheet_seo_title: 'CSSBuy Spreadsheet 2026 — Encontre e Compare Produtos',
  spreadsheet_seo_desc: 'Explore a CSSBuy Spreadsheet, encontre produtos, compare opções e veja guias sobre QC, envio, custos, armazém, segurança e compras.',
  article_category_spreadsheet: 'CSSBuy Spreadsheet',
  article_category_shipping: 'Shipping',
  article_category_safety: 'Safety',
  article_category_review: 'Review',
  article_category_coupon: 'Cupons',
  article_category_warehouse: 'Armazém',
  article_category_qc: 'Controle de Qualidade',
  article_category_comparison: 'Comparação',
  article_category_beginner: 'Guia para Iniciantes',
  shopping_guide: 'Guia de Compras',
  latest_articles_desc: 'Guias de compra, reviews e recursos de envio originais para usuários da CSSBuy Spreadsheet.',
  categories_desc: 'Navegue por todas as categorias de produtos na CSSBuy Spreadsheet e vá direto ao que você precisa.',
  article_review_title: 'CSSBuy Review 2026: Taxas, QC, Envio e Segurança',
  article_review_desc: 'Review honesto do CSSBuy cobrindo taxas, fotos de QC, armazém, custos de envio e segurança. CSSBuy é legítimo? Leia nossa análise de 2026.',
  article_coupon_title: 'CSSBuy Coupon & Discount Code 2026 — Guia',
  article_coupon_desc: 'Encontre informações sobre cupom e código de desconto do CSSBuy para 2026. Aprenda como as promoções funcionam e como verificar ofertas atuais.',
  article_warehouse_title: 'CSSBuy Warehouse Guide: Armazenamento, QC e Envio',
  article_warehouse_desc: 'Guia completo do armazém CSSBuy cobrindo armazenamento, inspeção de QC, consolidação e preparação do pacote antes do envio.',
  article_qc_title: 'CSSBuy QC Guide: Como Ler as Fotos de QC',
  article_qc_desc: 'Aprenda a ler as fotos de QC do CSSBuy e identificar problemas de qualidade antes do envio. Checklist completo para tênis e roupas.',
  article_alternatives_title: 'CSSBuy Alternatives 2026: Superbuy, Sugargoo e Mais',
  article_alternatives_desc: 'Compare o CSSBuy com Superbuy, Sugargoo, Oopbuy e AllChinaBuy. Encontre o melhor agente para suas necessidades em 2026.',
  article_beginner_title: 'Como Usar CSSBuy Spreadsheet: Guia para Iniciantes',
  article_beginner_desc: 'Novo no CSSBuy? Este guia para iniciantes explica como usar a spreadsheet, encontrar produtos, verificar QC e enviar seu primeiro pedido.',
  article_brazil_title: 'CSSBuy Envio para o Brasil: Custos e Alfândega',
  article_brazil_desc: 'Envio do CSSBuy para o Brasil explicado: métodos, custos, prazos e impostos de importação. Guia completo para compradores brasileiros.',
  article_germany_title: 'CSSBuy Envio para a Alemanha: Custos e Métodos',
  article_germany_desc: 'Envio do CSSBuy para a Alemanha: métodos disponíveis, custos, prazos e informações alfandegárias para compradores alemães.',
  article_shoes_title: 'CSSBuy Spreadsheet Tênis: Melhores Achados',
  article_shoes_desc: 'Descubra os melhores tênis e sneakers na CSSBuy Spreadsheet. Navegue por achados populares, compare vendedores e verifique o QC.',
  article_hoodies_title: 'CSSBuy Spreadsheet Moletons: Melhores Achados',
  article_hoodies_desc: 'Navegue pelos melhores moletons e blusas na CSSBuy Spreadsheet. Encontre estilos populares, compare vendedores e verifique fotos de QC.',
  featured_products: 'Produtos em Destaque',
  featured_products_desc: 'Produtos selecionados da CSSBuy Spreadsheet. Clique em qualquer item para ver detalhes e comprar.',
  all_products: 'Ver Todos os Produtos',
  products: 'Produtos',
  filter_all: 'Todos',
  back_to_top: 'Voltar ao Topo',
  products_title: 'Produtos CSSBuy Spreadsheet',
  products_subtitle: 'Explore todos os produtos da CSSBuy Spreadsheet. Filtre por categoria e clique em qualquer item para ver detalhes e comprar.',
};